"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _qs = require("qs");

var _qs2 = _interopRequireDefault(_qs);

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createApi = exports.createApi = function createApi(baseUrl, authFunc) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultLevel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "development";

  // Naive way of getting current level
  var level = process ? process.env.LEVEL : defaultLevel;

  // Allow to modify headers via config
  var headers = config.headers || {};
  delete config.headers;

  // Allow to modify transform response functions via config
  var transformResponse = config.transformResponse || [];
  delete config.transformResponse;

  return _axios2.default.create(_extends({
    baseURL: baseUrl,
    headers: _extends({
      Authorization: authFunc(),
      "X-Requested-With": "XMLHttpRequest"
    }, headers),
    paramsSerializer: function paramsSerializer(params) {
      return _qs2.default.stringify(params, { arrayFormat: "repeat" });
    },
    transformResponse: [function (data) {
      if (!data) {
        return data;
      }

      try {
        return (0, _utils.toCamelCase)(JSON.parse(data));
      } catch (err) {
        if (level !== "production") {
          console.warn("Remote URL does not respond with JSON, fallback to plain data.");
        }
        return data;
      }
    }].concat(_toConsumableArray(transformResponse))
  }, config));
};

exports.default = {
  createApi: createApi
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-utils-js/lib/api.js
 ** module id = 807
 ** module chunks = 0
 **/